import React from "react";
import { Slider } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { MAX_PERCENTAGE, MIN_PERCENTAGE } from "Utils";
import styles from "./percentageSlider.module.scss";

type PercentageSliderProps = {
  value: number | null;
  onChange: (value: number) => void;
  firstLabel: string;
  secondLabel: string;
  defaultValue?: number;
  className?: string;
  disabled?: boolean;
};

const PercentageSlider = ({
  value,
  onChange,
  firstLabel,
  secondLabel,
  defaultValue = 50,
  className,
  disabled,
}: PercentageSliderProps): React.JSX.Element => {
  const classNames = getClassName(styles.root, className);

  return (
    <div className={classNames}>
      <Slider
        value={value ?? defaultValue}
        marks={[
          { label: firstLabel, value: MIN_PERCENTAGE },
          { label: secondLabel, value: MAX_PERCENTAGE },
        ]}
        valueLabelDisplay="auto"
        onChange={(_e, data) => {
          if (typeof data === "number") {
            onChange(data);
          }
        }}
        disabled={disabled}
      />
    </div>
  );
};

export default PercentageSlider;
